import { ProductGalleryV2, ProductGalleryStyleV2Type, SourceTypeEnums } from '@commerce-product-webcomponents/ui';
import { Logger } from '@nextgen-web-framework/core';
import {
  Button,
  ButtonSize,
  ButtonStyles,
  ButtonWidth,
  Theme,
  PreviewPanel,
  useBreakpoint,
  Breakpoints,
  useTranslation,
} from '@nextgen-web-framework/all';
import { useState } from 'react';
import { ContentHeaderCard } from '@commerce-webcomponents/ui';
import logObject from '../../../logObject';
import styles from './ResourceOverview.module.scss';
import { type ResourceOverviewProps } from './types/propsTypes';

const ResourceOverview = (props: ResourceOverviewProps) => {
  const t = useTranslation();
  const [showModal, setShowModal] = useState<boolean>(false);
  const [galleryId, setGalleryId] = useState<string>('');
  const viewport = useBreakpoint() as Breakpoints;
  const { tag, description, title, subTitle, galleryList, cta } = props;
  const logger = Logger.getInstance(logObject('ResourceOverview.tsx'));
  const onOpenModal = (galleryId: string | number) => {
    setShowModal(true);
    setGalleryId(String(galleryId));
  };
  const onCloseModal = () => {
    setShowModal(false);
    setGalleryId('');
  };

  const downloadZipFile = () => {
    try {
      const fileUrl = cta?.url;
      window.open(fileUrl, '_blank');
    } catch (e) {
      logger.error('File download failed due to: - ', e);
    }
  };

  return (
    <>
      {showModal && (
        <PreviewPanel onClose={onCloseModal}>
          <ProductGalleryV2
            galleryList={galleryList}
            galleryId={galleryId}
            sourceKey={SourceTypeEnums.MODAL_GALLERY}
            productGalleryStyleType={ProductGalleryStyleV2Type.PRODUCT_GALLERY_MODAL}
          />
        </PreviewPanel>
      )}
      <div
        className={`${styles['content-detail-gallery-container']}`}
        data-testid={`resource-overview-container-testid`}
      >
        <div className={`${styles['content-detail-gallery']}`}>
          <div className={`${styles['content-detail-gallery-section']}`}>
            <ProductGalleryV2
              galleryId={galleryId}
              openModal={onOpenModal}
              sourceKey={SourceTypeEnums.PRODUCT_DETAIL_GALLERY}
              galleryList={galleryList}
            />
          </div>
          <div className={styles['content-container']}>
            <div className={styles['content-card']}>
              <ContentHeaderCard tag={tag} subTitle={subTitle} description={description} title={title} />
            </div>
            <div className={`${styles['cta-button']} sticky-bottom-bar`}>
              <Button
                title={cta?.cta || t('web.content.download')}
                buttonStyle={ButtonStyles.SOLID}
                theme={Theme.BLACK}
                size={[Breakpoints.XS, Breakpoints.SM].includes(viewport) ? ButtonSize.SMALL : ButtonSize.MEDIUM}
                buttonWidth={ButtonWidth.FULL_WIDTH}
                onClick={() => downloadZipFile()}
                data-testid="resource-cta-button"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default ResourceOverview;
